import { render, staticRenderFns } from "./AboutMaintenance.vue?vue&type=template&id=b66e7510&scoped=true&"
import script from "./AboutMaintenance.vue?vue&type=script&lang=js&"
export * from "./AboutMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66e7510",
  null
  
)

export default component.exports